// PendingTextPages.tsx — (B120) /data-deletion and /contact: public, pre-rendered pages the platform reviews read.
// (B120-1; planning 10-27 14:10) their approved text (legal-text.ts), indexed and in the sitemap.
import { LegalPage } from "./LegalPage.tsx";
import { DATA_DELETION, CONTACT } from "./legal-text.ts";

export function DataDeletionPage() {
  return <LegalPage title="Delete your TubeForge data" path="/data-deletion" text={DATA_DELETION}
    description="How to disconnect a YouTube, TikTok or Instagram account from TubeForge, or delete your whole account and its data." />;
}

export function ContactPage() {
  return <LegalPage title="Contact TubeForge" path="/contact" text={CONTACT}
    description="How to reach TubeForge: support, privacy and data requests, legal and security." />;
}
